import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'

import Divider from '@sputnik/components/Divider'
import { GetCreditApplicationDetails_creditApplication_CreditApplication } from '@sputnik/pages/DashboardPages/CreditApplicationsDataGrid/DashboardDetailsDrawer/GetCreditApplicationDetails.gql'

import ActionsNeededSection from './ActionsNeededSection'
import ApplicationOverview from './ApplicationOverview'
import InviteCollaboratorsSection from './InviteCollaboratorsSection'
import styles from './styles.module.scss'

interface ApplicationDetailsTabContentProps {
  setActiveTabToDocuments: () => void
  creditApplication: GetCreditApplicationDetails_creditApplication_CreditApplication
}

const ApplicationDetailsTabContent = ({
  setActiveTabToDocuments,
  creditApplication,
}: ApplicationDetailsTabContentProps) => {
  const [getClassName, makeTestId] = useNameFormatter('ApplicationDetailsTabContent')

  return (
    <div
      className={styles[getClassName('')]}
      data-testid={makeTestId('')}
    >
      <ActionsNeededSection
        creditApplication={creditApplication}
        setActiveTabToDocuments={setActiveTabToDocuments}
      />
      <ApplicationOverview creditApplication={creditApplication} />
      <Divider className={styles[getClassName('divider')]} />
      <InviteCollaboratorsSection salesforceCreditId={creditApplication?.salesforceCreditId} />
    </div>
  )
}

export default ApplicationDetailsTabContent
